import script from "./TableSpinner.vue?vue&type=script&setup=true&lang=js"
export * from "./TableSpinner.vue?vue&type=script&setup=true&lang=js"

import "./TableSpinner.vue?vue&type=style&index=0&id=62a2b8ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62a2b8ec"]])

export default __exports__